import { ApiModel } from './models/api.model';

export const API: ApiModel = {
  domains: {
    aus: 'https://staging.workshopsoftware.com.au',
    can: 'https://staging.workshopsoftware.com.au',
    gbr: 'https://staging.workshopsoftware.com.au',
    usa: 'https://staging.workshopsoftware.com.au'
  },
  subdomain: 'staging',
  url      : SERVER_ENDPOINT || '/api'
};
